function fixTextBlockHeights() {
    $(".product_wrapper a.product .product-description").removeAttr("style");
    let $descriptions = $(".product_wrapper a.product .product-description");
    let perRow = (window.innerWidth < 1024) ? 2 : 4
    let count = 0;
    let elements = [];

    for (let index = 0; index < $descriptions.length; index++) {
      elements.push($descriptions[index]);
      if (count === perRow - 1) {
        setHeight(elements);
        count = 0;
        elements = [];
      } else {
        count++;
      }
    }
    // Incase the last row has less than X elements
    setHeight(elements);
}

// Fix the height of elements in the product grid
function setHeight(elements){
    var tallest = 0;
    for (var j = 0; j < elements.length; j++) {
    if ($(elements[j]).height() > tallest) {
        tallest = $(elements[j]).height();
    }
    }
    for (var j = 0; j < elements.length; j++) {
        $(elements[j]).height(tallest);
    }
}

export default fixTextBlockHeights;